import React from "react";
import Title from "../title";
import {
  Autocomplete,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const MainDetails = ({
  handleChange,
  formData,
  countries,
  handleCoursesChange,
}) => {
  return (
    <div className="main-details">
      <Title title="Main Details" />

      {/* Service Type Selector */}
      <FormControl fullWidth size="small">
        <InputLabel>Service Type</InputLabel>
        <Select
          value={formData.reading_type || "HTML"}
          label="Service Type"
          onChange={(e) => handleChange("reading_type", e.target.value)}
        >
          <MenuItem value="HTML">HTML</MenuItem>
          <MenuItem value="API">API</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Panel name"
        fullWidth
        variant="outlined"
        onChange={(e) => handleChange("smmpanel_name", e.target.value)}
        name="smmpanel_name"
        required
        size="small"
      />
      <TextField
        fullWidth
        variant="outlined"
        label="Panel Url"
        onChange={(e) => {
          handleChange("smmpanel_url", e.target.value);
        }}
        name="smmpanel_url"
        size="small"
        required
        type="text"
      />
      <div className="griddy-data">
        {/* HTML Fields */}
        {formData.reading_type === "HTML" && (
          <>
            <TextField
              label="Login user"
              fullWidth
              variant="outlined"
              onChange={(e) =>
                handleChange("smmpanel_loginuser", e.target.value)
              }
              name="smmpanel_loginuser"
              size="small"
            />
            <TextField
              label="Login password"
              fullWidth
              variant="outlined"
              onChange={(e) =>
                handleChange("smmpanel_login_password", e.target.value)
              }
              name="smmpanel_login_password"
              size="small"
            />
            <TextField
              label="URL service"
              fullWidth
              variant="outlined"
              onChange={(e) => handleChange("url_service", e.target.value)}
              name="url_service"
              type="text"
              size="small"
            />
          </>
        )}

        {/* API Fields */}
        {formData.reading_type === "API" && (
          <>
            <TextField
              label="API Key"
              fullWidth
              variant="outlined"
              onChange={(e) => handleChange("smmpanel_api_key", e.target.value)}
              name="smmpanel_api_key"
              size="small"
            />
            <TextField
              label="Api Url"
              fullWidth
              variant="outlined"
              onChange={(e) => handleChange("smmpanel_api_url", e.target.value)}
              name="smmpanel_api_url"
              size="small"
            />
          </>
        )}

        {/* Common Fields */}
        <TextField
          label="Ticket number"
          fullWidth
          variant="outlined"
          onChange={(e) =>
            handleChange("smmpanel_ticket_numper", e.target.value)
          }
          name="smmpanel_ticket_numper"
          size="small"
        />
        <LocalizationProvider dateAdapter={AdapterDayjs} className="w-full">
          <DatePicker
            label="Date of ticket"
            className="w-full"
            onChange={(newValue) => {
              const formattedDate = newValue?.format("YYYY-MM-DD") || null;
              handleChange("smmpanel_date_of_ticket", formattedDate);
            }}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
        <Autocomplete
          disablePortal
          options={countries}
          getOptionLabel={(option) => option.name || ""}
          onChange={handleCoursesChange}
          renderInput={(params) => (
            <TextField {...params} label="Countries" variant="outlined" />
          )}
        />
      </div>

      <TextField
        fullWidth
        variant="outlined"
        multiline
        label="Description"
        rows={5}
        onChange={(e) => handleChange("description", e.target.value)}
        name="description"
      />
      <TextField
        fullWidth
        variant="outlined"
        multiline
        label="Smmpanel notice"
        rows={5}
        onChange={(e) => handleChange("smmpanel_notice", e.target.value)}
        name="smmpanel_notice"
      />
    </div>
  );
};

export default MainDetails;
